import React, { useEffect, useState } from "react";

/** Slim reading-progress bar fixed to the very top of the page. */
export function ReadingProgress() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const h = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const p = h > 0 ? window.scrollY / h * 100 : 0;
        setProgress(Math.min(100, Math.max(0, p)));
      });
    };
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);
  return <div className="fixed left-0 right-0 top-0 z-[60] h-1 bg-transparent" data-id="element-208" data-mp="2y6ehbtydz96n">
      <div className="h-full bg-[var(--accent)] transition-[width] duration-150 ease-out" style={{
      width: `${progress}%`
    }} role="progressbar" aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100} aria-label="Progreso de lectura" data-id="element-209" data-mp="2y4brpb15bi2g" />
    </div>;
}